// extracted by mini-css-extract-plugin
export var resultList = "styles-module__resultList___HgH_A";
export var button = "styles-module__button___g5W3q";